(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zyqova-trust-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zyqova-trust-bar')) {
    class ZyqovaTrustBar extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.ready) return;
          this.ready = true;
          this.items = [...this.querySelectorAll('[data-trust-message]')];
          this.button = this.querySelector('[data-trust-toggle]');
          this.mobile = window.matchMedia('(max-width: 749px)');
          this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.index = 0;
          this.paused = this.motion.matches;
          this.refresh = () => {
            if (this.motion.matches) this.paused = true;
            this.paint();
            this.start();
          };
          this.resume = () => queueMicrotask(() => this.start());
          this.stopHandler = () => this.stop();
          this.toggle = () => {
            this.paused = !this.paused;
            this.paint();
            this.start(true);
          };
          this.mobile.addEventListener('change', this.refresh);
          this.motion.addEventListener('change', this.refresh);
          document.addEventListener('visibilitychange', this.refresh);
          this.addEventListener('mouseenter', this.stopHandler);
          this.addEventListener('mouseleave', this.resume);
          this.addEventListener('focusin', this.stopHandler);
          this.addEventListener('focusout', this.resume);
          this.button?.addEventListener('click', this.toggle);
          this.refresh();
        });
      }
      paint() {
        this.items.forEach((item, index) => item.toggleAttribute('data-active', index === this.index));
        this.dataset.paused = String(this.paused);
        if (this.button) {
          this.button.hidden = !this.mobile.matches || this.items.length < 2;
          this.button.setAttribute('aria-pressed', String(this.paused));
          this.button.setAttribute('aria-label', this.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        }
      }
      start(userInitiated = false) {
        this.stop();
        if (!this.isConnected || !this.mobile.matches || this.items.length < 2 || this.paused || document.hidden) return;
        const hovering = window.matchMedia('(hover: hover)').matches && this.matches(':hover');
        if (!userInitiated && (hovering || this.contains(document.activeElement))) return;
        const interval = Math.max(4, Number(this.dataset.interval) || 5) * 1000;
        this.timer = window.setInterval(() => {
          this.index = (this.index + 1) % this.items.length;
          this.paint();
        }, interval);
      }
      stop() {
        window.clearInterval(this.timer);
        this.timer = undefined;
      }
      disconnectedCallback() {
        this.stop();
        if (!this.ready) return;
        this.mobile.removeEventListener('change', this.refresh);
        this.motion.removeEventListener('change', this.refresh);
        document.removeEventListener('visibilitychange', this.refresh);
        this.removeEventListener('mouseenter', this.stopHandler);
        this.removeEventListener('mouseleave', this.resume);
        this.removeEventListener('focusin', this.stopHandler);
        this.removeEventListener('focusout', this.resume);
        this.button?.removeEventListener('click', this.toggle);
        this.ready = false;
      }
    }
    customElements.define('zyqova-trust-bar', ZyqovaTrustBar);
  }

  } catch(e) { console.error(e); }
})();
})();
